import { render } from "./ReTag.vue?vue&type=template&id=76e06462&scoped=true"
import script from "./ReTag.vue?vue&type=script&lang=js"
export * from "./ReTag.vue?vue&type=script&lang=js"

import "./ReTag.vue?vue&type=style&index=0&id=76e06462&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e06462"]])

export default __exports__